import { FirearmStorageLocationPLIService } from './firearm-storage-location-pli.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { FIREARM_STORAGE_LOCATION_PLI_TYPE, FirearmStorageLocationPLI } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class FirearmStorageLocationPLIResolverBase implements Resolve<FirearmStorageLocationPLI> {

  constructor(protected service: FirearmStorageLocationPLIService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FirearmStorageLocationPLI> {
    const key: number = FIREARM_STORAGE_LOCATION_PLI_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



